export const ProjectInfo = ({ projectInfo }: any) => {
  return (
    <section aria-labelledby='applicant-information-title'>
      <div className='bg-white shadow sm:rounded-lg'>
        <div className='py-5'>
          <div className='px-4 py-2 sm:px-6 border-l-4 border-primaryColor-normal'>
            <h2 id='applicant-information-title' className='m-0 text-lg leading-6 font-medium text-primaryColor-normal'>
              Project Information
            </h2>
            <p className='mt-1 max-w-2xl text-sm text-gray-500'>Information about your project</p>
          </div>
        </div>
        <div className='border-t border-gray-200 px-4 py-5 sm:px-6'>
          <dl className='grid grid-cols-1 gap-x-4 gap-y-8 sm:grid-cols-2 mb-8'>
            <div className='sm:col-span-2'>
              <dt className='text-sm font-medium text-gray-500'>Do you have project you would like to complete ?</dt>
              <dd className='mt-1 text-sm text-gray-900'>{projectInfo.q1}</dd>
            </div>
            {projectInfo.q1 === 'yes' && (
              <>
                <div className='sm:col-span-1'>
                  <dt className='text-sm font-medium text-gray-500'>Property Address for Project</dt>
                  <dd className='mt-1 text-sm text-gray-900'>{projectInfo['q1-propertyAddress']}</dd>
                </div>
                <div className='sm:col-span-1'>
                  <dt className='text-sm font-medium text-gray-500'>Legal Property Owner</dt>
                  <dd className='mt-1 text-sm text-gray-900'>{projectInfo['q1-propertyOwner']}</dd>
                </div>
                {projectInfo['q1-f3'] && (
                  <div className='sm:col-span-1'>
                    <dt className='text-sm font-medium text-gray-500'>Status of Site Control</dt>
                    <dd className='mt-1 text-sm text-gray-900'>{projectInfo['q1-f3']}</dd>
                  </div>
                )}
                {projectInfo['q1-propertyOwnerEmail'] && (
                  <div className='sm:col-span-1'>
                    <dt className='text-sm font-medium text-gray-500'>Email</dt>
                    <dd className='mt-1 text-sm text-gray-900'>{projectInfo['q1-propertyOwnerEmail']}</dd>
                  </div>
                )}
                <div className='sm:col-span-2'>
                  <dt className='text-sm font-medium text-gray-500'>Is Property currently vacant ?</dt>
                  <dd className='mt-1 text-sm text-gray-900'>{projectInfo['q1-propertyCurrentlyVacant']}</dd>
                </div>
                {projectInfo['q1-propertyCurrentlyVacant'] === 'yes' && (
                  <>
                    <div className='sm:col-span-1'>
                      <dt className='text-sm font-medium text-gray-500'>What is currently located on the site ?</dt>
                      <dd className='mt-1 text-sm text-gray-900'>{projectInfo['q1-currentSite']}</dd>
                    </div>
                    <div className='sm:col-span-1'>
                      <dt className='text-sm font-medium text-gray-500'>Development Project Status ?</dt>
                      <dd className='mt-1 text-sm text-gray-900'>{projectInfo['q1-developmentProjectStatus']}</dd>
                    </div>
                  </>
                )}
                <div className='sm:col-span-2'>
                  <dt className='text-sm font-medium text-gray-500'>Do you have legal counsel for this project ?</dt>
                  <dd className='mt-1 text-sm text-gray-900'>{projectInfo['q1-haveLegalCounsel']}</dd>
                </div>
                <div className='sm:col-span-2'>
                  <dt className='text-sm font-medium text-gray-500'>Do you have a development consultant or development partner ?</dt>
                  <dd className='mt-1 text-sm text-gray-900'>{projectInfo['q1-haveConsultantPartner']}</dd>
                </div>
                <div className='sm:col-span-2'>
                  <dt className='text-sm font-medium text-gray-500'>Do you have market analysis ?</dt>
                  <dd className='mt-1 text-sm text-gray-900'>{projectInfo['q1-haveMarketAnalysis']}</dd>
                </div>
                <div className='sm:col-span-2'>
                  <dt className='text-sm font-medium text-gray-500'>Do you have a development budget and pro forma for project ?</dt>
                  <dd className='mt-1 text-sm text-gray-900'>{projectInfo['q1-haveDevelopmentBudgetProforma']}</dd>
                </div>
              </>
            )}
          </dl>
        </div>
      </div>
    </section>
  );
};
